import PageNotFoundRedirect from 'components/PageNotFoundRedirect';
import { useAccountContext } from 'utils/account/AccountContext';

export const flags = {
  ALERT_MANAGER: 'ALERT_MANAGER',
  BLADE_AI: 'BLADE_AI',
  COLLABORATORS: 'COLLABORATORS',
  COST_MANAGEMENT: 'COST_MANAGEMENT',
  DAMAGE_SCHEMA: 'DAMAGE_SCHEMA',
  DEVICE_FIRMWARE_MANAGEMENT: 'DEVICE_FIRMWARE_MANAGEMENT',
  HORIZON_DAMAGES: 'HORIZON_DAMAGES',
  HORIZON_GRID_IMPORT: 'HORIZON_GRID_IMPORT',
  INSPECTION_DELIVERY: 'INSPECTION_DELIVERY',
  INSPECTION_UPLOAD: 'INSPECTION_UPLOAD',
  LEGACY_DAMAGES: 'LEGACY_DAMAGES',
  MAXIMO_SRS: 'MAXIMO_SRS',
  SISENSE: 'SISENSE',
  SKYCRAWLER_UPLOAD: 'SKYCRAWLER_UPLOAD',
  UPLOADS: 'UPLOADS',
  WORK_ORDERS: 'WORK_ORDERS',
  DAMAGE_INGESTION: 'DAMAGE_INGESTION',
  DAMAGES_2_NO_PRE_LOADING: 'DAMAGES_2_NO_PRE_LOADING',
  DAMAGES_INBOX: 'DAMAGES_INBOX',
  OVERRIDE_SCHEDULE_VIS_SITE_RESTRICTIONS: 'OVERRIDE_SCHEDULE_VIS_SITE_RESTRICTIONS',
  RISK_MANAGEMENT: 'RISK_MANAGEMENT',
} as const;

// the name of a real entitlement — use instead of `string` when a value must be a flag.
export type FeatureFlagName = (typeof flags)[keyof typeof flags];

export const useFeatures = () => {
  const { features, featuresLoading, featuresError } = useAccountContext();

  return { features, loading: featuresLoading, error: featuresError };
};

export interface FeatureFlagProps {
  children: React.ReactNode;
  errorMessageIfNoAccess?: string;
  flag: string;
  redirectUrlIfNoAccess?: string;
}

export const FeatureFlag = ({
  children,
  errorMessageIfNoAccess,
  flag,
  redirectUrlIfNoAccess,
}: FeatureFlagProps) => {
  const { features } = useFeatures();

  if (!features[flag]) {
    if (redirectUrlIfNoAccess) {
      return (
        <PageNotFoundRedirect
          errorMessage={errorMessageIfNoAccess}
          redirectUrl={redirectUrlIfNoAccess}
        />
      );
    }
    return null;
  }

  return <>{children}</>;
};
